import Widget from "lib/widget";

import GeocompletedAddress, { syncCustomAddressFields }  from 'widgets/geocompletedAddress'

import $              from "jquery"
import select2        from "select2"
import { createNewTag } from "lib/select2NewTag"
import "select2/dist/css/select2.min.css"
import "select2-bootstrap-theme/dist/select2-bootstrap.min.css"

class NewFormWidget extends Widget {
  bind() {
    // Client
    this.clientNameSelect    = $(this.root.find('#new_project_form_client_name'))
    this.clientCompanySelect = $(this.root.find('#new_project_form_client_company_name'))
    this.clientEmail         = $(this.root.find('#new_project_form_client_email'))
    this.clientPhoneNumber   = $(this.root.find('#new_project_form_client_phone_number'))

    // Applicant
    this.contactNameSelect    = $(this.root.find('#new_project_form_contact_name'))
    this.contactEmail         = $(this.root.find('#new_project_form_contact_email'))
    this.contactPhoneNumber   = $(this.root.find('#new_project_form_phone_number'))
        
    bindAddressLocator.call(this);
    bindCustomWorkDescriptions.call(this);
    toggleAdditionalWorksDescription.call(this, this.root.find('.works-description').val());
    bindProjectType.call(this);
    bindSelectProjectType.call(this);

    bindClientNameSelect.call(this)
    bindClientCompanySelect.call(this)
    bindContactNameSelect.call(this)
  }
}

const enableDisableClientFields = function() {
  // If greater than zero, must be an existing record
  if (this.clientNameSelect.val() > 0) {
    this.clientCompanySelect.attr('readonly', false)
    this.clientEmail.prop('readonly', false)
    this.clientPhoneNumber.prop('readonly', false)
  } else {
    this.clientCompanySelect.attr('readonly', false)
    this.clientEmail.prop('readonly', false)
    this.clientPhoneNumber.prop('readonly', false)
  }
}

const enableDisableContactFields = function() {
  // If greater than zero, must be an existing record
  if (this.contactNameSelect.val() > 0) {
    this.contactEmail.prop('readonly', true)
    this.contactPhoneNumber.prop('readonly', true)
  } else {
    this.contactEmail.prop('readonly', false)
    this.contactPhoneNumber.prop('readonly', false)
  }
}

const bindAddressLocator = function() {
  const elem1 = this.root.find('#client-address-fields-group')
  const elem2 = this.root.find('#address-fields-group')

  const elems = [elem1, elem2]

  elems.forEach(elem => {
    new GeocompletedAddress({
      root: elem,
      options: {
        types: ['address'],
        country: 'AU'
      }
    });

    syncCustomAddressFields(elem)
  })

};

const bindSelectProjectType = function() {
  this.root.find('.select-project-type').on('change', (e) => {
    const isCdc = ['cdc', 'cdc_pool', 'cdc_demo'].includes($(e.target).val())
    const isCc = ['cc', 'cc_pool'].includes($(e.target).val())

    if (isCdc) {
      $('.cdc-checklist').removeClass('d-none')
    } else {
      $('.cdc-checklist').addClass('d-none')
    }

    if (isCc) {
      $('.cc-checklist').removeClass('d-none')
    } else {
      $('.cc-checklist').addClass('d-none')
    }

    $('[data-consent-label]').text(isCc ? 'Development Consent' : 'EPIs')
  })
}

const bindCustomWorkDescriptions = function() {
  this.root.find('.works-description').on('change', (e) => {
    toggleAdditionalWorksDescription.call(this, e.currentTarget.value)
  })
}

const toggleAdditionalWorksDescription = function(value) {
  if (value == 'custom') {
    this.root.find('.additional-works-description').removeClass('d-none')
    this.root.find('.additional-works-description input').prop('disabled', false)
  } else {
    this.root.find('.additional-works-description').addClass('d-none')
    this.root.find('.additional-works-description input').prop('disabled', true)
  }
}

const bindProjectType = function() {
  this.root.find('.submit-checklist-template').on('click', (e) => {
    let selected = this.root.find('.select-checklist').val()
    console.log(selected);
    this.root.find("input.project-type").val(selected)
    this.root.find("form").submit()
  })
}

var bindContactNameSelect = function() {
  this.contactNameSelect.select2({
    placeholder: 'Search or Add New Contact',
    minimumInputLength: 1,
    allowClear: true,
    tags: true,
    createTag: createNewTag,
    ajax: {
      url: '/select_data/users',
      dataType: 'json',
      delay: 250,
      data: (params) => {
        return {
          by_keyword: params.term,
          role: 'applicant'
        }
      },
      processResults: (data, page) => {
        return {
          results: data.collection,
          pagination: data.pagination
        }
      },
      cache: true
    }});

  this.contactNameSelect.on('select2:select', (e) => {
    let user = _.get(e.params, 'data', {})

    this.contactEmail.val(_.get(user, 'email', ""))
    this.contactPhoneNumber.val(_.get(user, 'phone_number', ""))

    enableDisableContactFields.call(this)

    // let account = _.get(user, 'accounts', [])[0]
    // if (account != undefined) {
    //   this.contactCompanySelect.select2("trigger", "select", {
    //     data: account
    //   });
    // }
  });

  this.contactNameSelect.on('select2:unselect', (e) => {
    this.contactEmail.val('')
    this.contactPhoneNumber.val('')
    enableDisableContactFields.call(this)
  });
}

var bindClientNameSelect = function() {
  this.clientNameSelect.select2({
    placeholder: 'Search or Add New Client',
    minimumInputLength: 1,
    allowClear: true,
    tags: true,
    createTag: createNewTag,
    ajax: {
      url: '/select_data/users',
      dataType: 'json',
      delay: 250,
      data: (params) => {
        return {
          by_keyword: params.term,
          role: 'client'
        }
      },
      processResults: (data, page) => {
        return {
          results: data.collection,
          pagination: data.pagination
        }
      },
      cache: true
    }});

  this.clientNameSelect.on('select2:select', (e) => {
    let user = _.get(e.params, 'data', {})

    this.clientEmail.val(_.get(user, 'email', ""))
    this.clientPhoneNumber.val(_.get(user, 'phone_number', ""))

    let account = _.get(user, 'accounts', [])[0]
    if (account != undefined) {
      this.clientCompanySelect.select2("trigger", "select", {
        data: account
      });
    }

    enableDisableClientFields.call(this)
  });

  this.clientNameSelect.on('select2:unselect', (e) => {
    this.clientCompanySelect.val('').trigger('change')
    this.clientEmail.val('')
    this.clientPhoneNumber.val('')
    enableDisableClientFields.call(this)
  });
}

const bindClientCompanySelect = function() {
  this.clientCompanySelect.select2({
    placeholder: '',
    minimumInputLength: 1,
    allowClear: true,
    tags: true,
    createTag: createNewTag,
    ajax: {
      url: '/select_data/accounts',
      dataType: 'json',
      delay: 250,
      data: (params) => {
        return { by_keyword: params.term }
      },
      processResults: (data, page) => {
        return {
          results: data.collection,
          pagination: data.pagination
        }
      },
      cache: true,
    }});
}

export default NewFormWidget;
